import SpindlApi from './SpindlApi.js';
export default SpindlApi;


// WEBPACK FOOTER //
// ./src/modules/spindl-api/index.js